<div *ngIf="isOpen" class="alert-bar {{ variant }} {{ position }}">
  <div style="position: relative; padding: 2px 10px 0 2px">
    <span class="text" [innerHTML]="message">
    <!-- {{ message }} -->
  </span>
    <span (click)="isOpen = false" class="material-icons close-icon">
    close
  </span>
  </div>
</div>
